import getFormatVersion from "./getFormatVersion";

// Removed hook as it caused render issues...
export default function getDisplayVersion(v: string, latestVersion: string): string {
  return v === latestVersion ? `${getFormatVersion(v)}` : v;
}
